/** B3.1 snap distance bands — defaults match docs; overridable in Settings. */

export const SNAP_BAND_LIMITS = {
  autoMin: 1,
  autoMax: 15,
  searchMin: 3,
  searchMax: 25,
} as const;

export type RoadSnapBandConfig = {
  /** Endpoints within this distance auto-move on finish (when unambiguous). */
  autoM: number;
  /** API search radius and upper bound for assisted / confirm band. */
  searchM: number;
};

export const DEFAULT_ROAD_SNAP_BANDS: RoadSnapBandConfig = {
  autoM: 3,
  searchM: 8,
};

export function normalizeRoadSnapBands(partial: {
  autoM?: number;
  searchM?: number;
}): RoadSnapBandConfig {
  let autoM = partial.autoM ?? DEFAULT_ROAD_SNAP_BANDS.autoM;
  let searchM = partial.searchM ?? DEFAULT_ROAD_SNAP_BANDS.searchM;
  autoM = Math.min(SNAP_BAND_LIMITS.autoMax, Math.max(SNAP_BAND_LIMITS.autoMin, autoM));
  searchM = Math.min(SNAP_BAND_LIMITS.searchMax, Math.max(SNAP_BAND_LIMITS.searchMin, searchM));
  if (searchM < autoM) {
    searchM = autoM;
  }
  return { autoM, searchM };
}

export function roadSnapBandsFromSettings(settings: {
  roadSnapAutoRadiusM?: number;
  roadSnapSearchRadiusM?: number;
}): RoadSnapBandConfig {
  return normalizeRoadSnapBands({
    autoM: settings.roadSnapAutoRadiusM,
    searchM: settings.roadSnapSearchRadiusM,
  });
}
